import styled from 'styled-components'

export const StyledChartContainer = styled.div`
  margin: 0 0 50px  
`
